import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAllUsers } from '../api/Index'
import './Users.css'
import PageTitle from '../components/UI/PageTitle'
import Separator from '../components/UI/Separator';
import { CiEdit } from 'react-icons/ci';

const Users = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getAllUsers();
                setUsers(response.data);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching users:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const handleEditUser = (userId) => {
        navigate(`/edit-user?id=${userId}`);
    };

    const UserCard = ({ user }) => {
        return (
            <div>
                <div className="user-profile-container">
                    <div>
                        <h5 className='user-profile-name'>{(user.name || 'Unknown').toUpperCase()}</h5>
                        <p>Email: {user.email || 'N/A'}</p>
                        <p>Phone: {user.phone || 'N/A'}</p>
                        <p>Role: <span className='user-profile-role'>{user.role || 'user'}</span></p>
                    </div>
                    <div>
                        <p className='user-status'>{user.status || 'Active'}</p>
                    </div>
                </div>
                <button onClick={() => handleEditUser(user._id || user.id)}>
                    <CiEdit /> Edit
                </button>
            </div>
        );
    };

    if (loading) {
        return (
            <div>
                <PageTitle title="Users" />
                <div>Loading users...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <PageTitle title="Users" />
                <div style={{color: 'red'}}>Error: {error}</div>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Users" />
            <div className="users-container">
                {users.length === 0 ? (
                    <div>No users found.</div>
                ) : (
                    users.map(user => (
                        <div key={user._id || user.id}>
                            <Separator />
                            <UserCard user={user} />
                        </div>
                    ))
                )}
            </div>
        </div>
  )
}

export default Users